import { Link } from 'react-router-dom';
import { services } from '@/mocks/services';

export default function Services() {
  return (
    <section id="services" className="section-padding bg-background-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-12 md:mb-16">
          <div>
            <p className="text-primary-500 font-bold text-sm tracking-widest uppercase mb-2">
              SANA NE LAZIM?
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-50 tracking-tighter">
              İŞİMİZ BU
            </h2>
          </div>
          <a href="#contact" className="btn-outline text-sm font-bold uppercase tracking-wider">
            Hadi Konuşalım
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        {/* Quick Answer — GEO Entity Summary */}
        <p className="text-sm md:text-base text-foreground-400 mb-10 md:mb-12 font-medium max-w-3xl speakable-summary">
          BIFF Digital olarak marka konumlandırması, dijital reklam yönetimi, web ve yazılım geliştirme, e-ticaret danışmanlığı, B2B lead generation ve içerik üretimi olmak üzere altı ana hizmet alanında, Ankara, İstanbul ve İzmir&apos;deki müşterilerimize 5 yıldır veri odaklı ve ölçülebilir sonuçlar sunuyoruz.
        </p>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {services.map((service, idx) => (
            <div
              key={service.id}
              className="glass-card-hover rounded-2xl p-6 md:p-8 group"
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              <div className="w-14 h-14 bg-background-200 rounded-xl flex items-center justify-center mb-5 group-hover:bg-primary-500/10 transition-colors duration-300">
                <i className={`${service.icon} text-2xl text-primary-500`} />
              </div>
              <h3 className="text-lg md:text-xl font-bold text-foreground-50 mb-3 group-hover:text-primary-500 transition-colors">
                {service.title}
              </h3>
              <p className="text-sm md:text-base text-foreground-400 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        {/* Link to full services page */}
        <div className="mt-10 text-center">
          <Link to="/hizmetler" className="inline-flex items-center gap-2 text-sm font-bold text-primary-500 hover:text-primary-600 transition-colors uppercase tracking-wider">
            Tüm Hizmetlerimiz ve Detaylar
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* CTA Banner */}
        <div className="mt-10 md:mt-14 glass-card rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-xl md:text-2xl font-bold text-foreground-50 mb-2">
              Projeni Hayata Geçirelim
            </h3>
            <p className="text-sm md:text-base text-foreground-400">
              Hangi hizmetimiz hakkında daha detaylı bilgi almak istiyorsun? Uzman ekibimizle görüş, sana özel çözümleri konuşalım.
            </p>
          </div>
          <a href="#contact" className="btn-primary shrink-0">
            Ücretsiz Danışmanlık
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}